(() => {
  if (window.__ewaMobileProductMediaLoaded) return;
  window.__ewaMobileProductMediaLoaded = true;

  const mobileQuery = window.matchMedia('(max-width: 767px)');

  const repositionCard = (card) => {
    if (!card) return;

    const wrap = card.querySelector('.hdt-main-product-wrap');
    const media = card.querySelector('.hdt-product-media-wrapps');
    const group = card.querySelector('.hdt-group-product-block');
    const info = group ? group.querySelector('.hdt-product-info__list') : null;
    const price = info ? info.querySelector('.hdt-product__price') : null;

    if (!wrap || !media || !group || !info) return;

    if (mobileQuery.matches) {
      const anchor = price
        || info.querySelector('.jdgm-preview-badge')
        || info.querySelector('.hdt-product__title')
        || info.firstElementChild;

      if (anchor) {
        if (media.parentElement !== info || media.previousElementSibling !== anchor) {
          anchor.insertAdjacentElement('afterend', media);
        }
      } else if (media.parentElement !== info) {
        info.prepend(media);
      }

      media.classList.add('ewa-product-media--mobile-position');
      card.classList.add('ewa-mobile-media-positioned');
    } else {
      if (media.parentElement !== wrap || media.nextElementSibling !== group) {
        wrap.insertBefore(media, group);
      }

      media.classList.remove('ewa-product-media--mobile-position');
      card.classList.remove('ewa-mobile-media-positioned');
    }
  };

  const repositionAll = (root = document) => {
    const cards = root.matches?.('.ewa-product-card')
      ? [root]
      : root.querySelectorAll?.('.ewa-product-card') || [];

    cards.forEach(repositionCard);
  };

  const schedule = (root = document) => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => repositionAll(root));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => schedule(document), { once: true });
  } else {
    schedule(document);
  }

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', () => schedule(document));
  } else {
    mobileQuery.addListener(() => schedule(document));
  }

  document.addEventListener('shopify:section:load', (event) => schedule(event.target));
  document.addEventListener('shopify:section:select', (event) => schedule(event.target));
  document.addEventListener('shopify:block:select', (event) => schedule(event.target));
})();
